export const EPIC_LINK_SEARCHER_KEY = 'com.pyxis.greenhopper.jira:gh-epic-link-searcher';
export const PARENT_LINK_SEARCHER_KEY = 'com.atlassian.jpo:jpo-custom-field-parent-searcher';
